import { render, staticRenderFns } from "./ActivationTaskIcon.vue?vue&type=template&id=1c856d92&"
import script from "./ActivationTaskIcon.vue?vue&type=script&lang=js&"
export * from "./ActivationTaskIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports